import { useCallback, useRef } from 'react'
import { useAuthStore } from '../stores/authStore'

export const useSessionExpiration = () => {
  const { isAuthenticated, showSessionExpiredModal } = useAuthStore()
  const loginTimeRef = useRef<number>(0)

  const handleAuthError = useCallback((error: any) => {
    console.log('handleAuthError called:', {
      status: error?.response?.status,
      isAuthenticated,
      url: error.config?.url,
      timeSinceLogin: Date.now() - loginTimeRef.current
    })
    
    // TEMPORARILY DISABLED - Session expiration modal causing issues
    // Just log the error and let components handle it normally
    if (error?.response?.status === 401 && isAuthenticated) {
      console.log('401 error detected, but not showing session expired modal')
    }
    
    return false // Never show session expired modal for now
  }, [isAuthenticated, showSessionExpiredModal])

  // Track when user becomes authenticated (login time)
  const trackLogin = useCallback(() => {
    if (isAuthenticated) {
      loginTimeRef.current = Date.now()
      console.log('Login tracked at:', new Date(loginTimeRef.current).toISOString())
    }
  }, [isAuthenticated])

  const isSessionExpired = useCallback((error: any) => {
    return error?.response?.status === 401 && isAuthenticated
  }, [isAuthenticated])

  return {
    handleAuthError,
    isSessionExpired,
    trackLogin
  }
}
